var map = {
	"./banner/banner_jig.jpg": 6470,
	"./banner/banner_jig_2.jpg": 1293,
	"./banner/banner_talentpool.jpg": 9462,
	"./banner/coe/jobs_banner.jpg": 9440,
	"./banner/coe/skilled_banner.jpg": 4960,
	"./banner/coe/slide-4.jpg": 3869,
	"./banner/coe/welcome_banner.jpg": 4772,
	"./banner/edunetasia/jobs_banner.jpg": 4560,
	"./banner/edunetasia/skilled_banner.jpg": 3968,
	"./banner/edunetasia/slide-4.jpg": 4077,
	"./banner/edunetasia/welcome_banner.jpg": 3188,
	"./banner/edunetin/jobs_banner.jpg": 2059,
	"./banner/edunetin/skilled_banner.jpg": 973,
	"./banner/edunetin/slide-4.jpg": 5334,
	"./banner/edunetin/welcome_banner.jpg": 6809,
	"./banner/edunetke/jobs_banner.jpg": 5806,
	"./banner/edunetke/skilled_banner.jpg": 1282,
	"./banner/edunetke/slide-4.jpg": 827,
	"./banner/edunetke/welcome_banner.jpg": 8901,
	"./banner/edunetma/jobs_banner.jpg": 9736,
	"./banner/edunetma/skilled_banner.jpg": 5528,
	"./banner/edunetma/slide-4.jpg": 5445,
	"./banner/edunetma/welcome_banner.jpg": 2780,
	"./banner/jobs_banner.jpg": 4378,
	"./banner/kle/jobs_banner.jpg": 1549,
	"./banner/kle/skilled_banner.jpg": 5451,
	"./banner/kle/slide-4.jpg": 3768,
	"./banner/kle/welcome_banner.gif": 6768,
	"./banner/skilled_banner.jpg": 7934,
	"./banner/slide-1.jpg": 7758,
	"./banner/slide-2.jpg": 1465,
	"./banner/slide-3.jpg": 6092,
	"./banner/slide-4.jpg": 439,
	"./banner/welcome_banner.jpg": 3342,
	"./box-1.jpg": 2855,
	"./box-2.jpg": 2872,
	"./box-3.jpg": 7189,
	"./box-4.jpg": 1566,
	"./flags/ar.svg": 3551,
	"./flags/at.svg": 881,
	"./flags/bg.svg": 2891,
	"./flags/bq.svg": 7221,
	"./flags/cs.svg": 2116,
	"./flags/cz.svg": 957,
	"./flags/de.svg": 115,
	"./flags/de2.svg": 1675,
	"./flags/de_a.svg": 7283,
	"./flags/en.svg": 1215,
	"./flags/es.svg": 6074,
	"./flags/fa.svg": 49,
	"./flags/fr.svg": 5506,
	"./flags/hr.svg": 8264,
	"./flags/ir.svg": 6103,
	"./flags/it.svg": 185,
	"./flags/nl.svg": 8812,
	"./flags/pl.svg": 582,
	"./flags/pt.svg": 3326,
	"./flags/ro.svg": 3715,
	"./flags/ru.svg": 1705,
	"./flags/sk.svg": 5116,
	"./flags/sr.svg": 4421,
	"./flags/tr.svg": 8588,
	"./flags/uk.svg": 1842,
	"./flags/vi.svg": 9449,
	"./group-sidebar/development.svg": 4866,
	"./group-sidebar/durations.svg": 3674,
	"./group-sidebar/education.svg": 5499,
	"./group-sidebar/example-job.svg": 6497,
	"./group-sidebar/trend.svg": 972,
	"./immigration-guide.png": 1859,
	"./logo-ABA-work.svg": 2980,
	"./logo-ABA.svg": 5770,
	"./logo-work-talent.svg": 5786,
	"./logo/footer-logo-jig.png": 6044,
	"./logo/header-logo-jig.png": 2060,
	"./logo/logo-amseu.svg": 8171,
	"./logo/logo-coe.svg": 6395,
	"./logo/logo-coe_inv.png": 2951,
	"./logo/logo-he.png": 8683,
	"./logo/logo-jnjts.svg": 2193,
	"./logo/logo-jobmatch.svg": 1984,
	"./logo/logo-kh.png": 3247,
	"./logo/logo-kle.png": 7422,
	"./logo/logo-kle.svg": 3102,
	"./logo/logo-ncph.png": 9251,
	"./logo/logo-ragtp.svg": 7002,
	"./logo/logo-rhh.png": 8862,
	"./logo/logo-rhh33.png": 6924,
	"./logo/logo-t4a.png": 7005,
	"./logo/logo-wconat.png": 3448,
	"./logo/logo-work-edunet-OLD.png": 3365,
	"./logo/logo-work-edunet.png": 5321,
	"./logo/logo-work-edunetasia.png": 9003,
	"./logo/logo-work-edunetke.png": 2433,
	"./logo/logo-work-edunetma.png": 2547,
	"./logo/logo-work-talenpool.svg": 3632,
	"./logo/logo_wrktp.png": 1392,
	"./photo-placeholder-men.png": 4017,
	"./photo-placeholder-woman.png": 2571,
	"./photo-placeholder.jpg": 4018,
	"./the-essential-guide.png": 1223,
	"./themes/logo-work-talent.svg": 275,
	"./themes/logo-work-talentpool.svg": 813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;